var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBackArrowLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.828 7.00066H15.5C15.7761 7.00066 16 7.22451 16 7.50066V8.50066C16 8.7768 15.7761 9.00066 15.5 9.00066H3.828L8.83845 14.0111C9.03371 14.2064 9.03371 14.5229 8.83845 14.7182L8.13155 15.4251C7.93629 15.6204 7.61971 15.6204 7.42445 15.4251L0.353553 8.35421C0.158291 8.15895 0.158291 7.84236 0.353553 7.6471L7.42445 0.57621C7.61971 0.380948 7.93629 0.380947 8.13155 0.57621L8.83845 1.2831C9.03371 1.47837 9.03371 1.79495 8.83845 1.99021L3.828 7.00066Z",
    fill: "#19305A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/backArrowLeft.2592c54d.svg";
export { ForwardRef as ReactComponent };